import { render, staticRenderFns } from "./TranslationsList.vue?vue&type=template&id=169c5556&scoped=true&"
import script from "./TranslationsList.vue?vue&type=script&lang=js&"
export * from "./TranslationsList.vue?vue&type=script&lang=js&"
import style0 from "./TranslationsList.vue?vue&type=style&index=0&id=169c5556&lang=scss&scoped=true&"
import style1 from "./TranslationsList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "169c5556",
  null
  
)

export default component.exports